const domainAppUserEn = {
  appUser: 'User',
  component: {
    AppUserActionButton: {
      createUser: 'Create User',
      deactivateUser: 'Deactivate User',
      describe: 'Do you want to delete this account?',
      noRecommendedAction: 'No recommended action',
      reactivateUser: 'Reactivate User',
      toolTipBlockedByRoleViolation: 'This account has a role violation (Violated Account Role). Resolve it before running this action.',
      toolTipCreateUserOnWebPage: 'Please Action "Create User" in the {{name}} Web page',
      toolTipDeactivateUserOnWebPage: 'Please Action "Deactivate User" in the {{name}} Web page',
      toolTipLicenseOperationNotSupported: 'This app does not support manual license grant/revoke. Licenses are assigned and removed automatically when the account is created or deleted.',
      toolTipReactivateUserOnWebPage: 'Please Action "Reactivate User" in the {{name}} Web page'
    },
    ChangePersonDialog: {
      Edit: 'Edit',
      assignPersonTitle: 'Assigning person to unidentified account',
      assignTo: 'Assign to',
      changePersonTitle: 'Change Person',
      noPerson: 'No Person associated',
      noPersonFound: 'No person found.',
      selectInputPlaceholder: 'Select Person...',
      unidentifiedAccount: 'Unidentified account'
    },
    LastActivityCell: {
      inactiveFor: 'Inactive for {{value}}'
    }
  },
  toast: {
    changeWorkerSuccess: 'Member assignment was updated.'
  }
};
export default domainAppUserEn;